import Header from "./components/Header";
import Hero from "./components/Hero";
import Categories from "./components/Categories";
import Ranking from "./components/Ranking";
import Recommendations from "./components/Recommendations";
import Roundups from "./components/Roundups";
import Reviews from "./components/Reviews";
import Faq from "./components/Faq";
import About from "./components/About";
import Footer from "./components/Footer";
import ScrollTop from "./components/ScrollTop";
import { faqs, ranking, siteName, works } from "@/mocks/works";

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    { "@type": "ListItem", position: 1, name: "首页", item: "https://javlist.github.io/" },
    { "@type": "ListItem", position: 2, name: "人妻动漫推荐与盘点", item: "https://javlist.github.io/#recommend" },
  ],
};

const rankingSchema = {
  "@context": "https://schema.org",
  "@type": "ItemList",
  name: `${siteName}人气口碑排行榜`,
  numberOfItems: ranking.length,
  itemListElement: ranking.map((r) => ({
    "@type": "ListItem",
    position: r.rank,
    name: r.title,
    description: `${r.genre}，同好评分 ${r.score.toFixed(1)}，${r.year} 年`,
  })),
};

const workSchema = {
  "@context": "https://schema.org",
  "@type": "ItemList",
  name: `${siteName}精选推荐作品`,
  numberOfItems: works.length,
  itemListElement: works.map((w, idx) => ({
    "@type": "ListItem",
    position: idx + 1,
    name: w.title,
    description: w.desc,
  })),
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(rankingSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(workSchema) }}
      />
      <Header />
      <main>
        <Hero />
        <Categories />
        <Ranking />
        <Recommendations />
        <Roundups />
        <Reviews />
        <Faq />
        <About />
      </main>
      <Footer />
      <ScrollTop />
    </>
  );
}